<script setup lang="ts">
import type { LoaderProps } from "./loader.types";
import { useLoader } from "./useLoader";

defineOptions({ name: "ELoader" });

const props = withDefaults(defineProps<LoaderProps>(), {
  variant: "circle",
  size: "md",
  color: "mono",
  complete: false,
});

const { variant, classes, fillCls } = useLoader({ props });
</script>

<template>
  <div :class="classes" class="e-loader" part="loader" role="presentation" aria-hidden="true">
    <div v-if="variant === 'bar'" :class="fillCls" part="loader-fill" />
  </div>
</template>

<style>
:host {
  display: contents;
}

@keyframes loader-bar {
  0% {
    transform: translateX(-250%);
  }
  50% {
    transform: translateX(350%);
  }
  100% {
    transform: translateX(-250%);
  }
}

@keyframes loader-bar-complete {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
</style>
